import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { TriarchHeader } from "@/components/triarch/TriarchHeader";
import { Footer } from "@/components/triarch/Footer";
import { ParticleSphereCanvas } from "@/components/triarch/ParticleSphereCanvas";
import { CursorLight } from "@/components/triarch/CursorLight";
import { EncryptedOverlay } from "@/components/triarch/EncryptedOverlay";
import { AccessModal } from "@/components/triarch/AccessModal";

export const TriarchLayout = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen overflow-x-hidden bg-[#07080A] text-white">
      {/* persistent fixed background layers */}
      {/* Continuous globe background is an identity element of the landing page only */}
      {isHome && (
        <div className="pointer-events-none fixed inset-0 z-0">
          <ParticleSphereCanvas />
        </div>
      )}
      <div className="triarch-noise pointer-events-none fixed inset-0 z-[1] opacity-[0.07]" />
      <CursorLight />
      <EncryptedOverlay />

      <div className="relative z-10 flex min-h-screen flex-col">
        <TriarchHeader />
        <AnimatePresence mode="wait">
          <motion.main
            key={location.pathname}
            initial={{ opacity: 0, y: 12, filter: "blur(6px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            exit={{ opacity: 0, y: -8, filter: "blur(6px)" }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="flex-1"
          >
            <Outlet />
          </motion.main>
        </AnimatePresence>
        <Footer />
      </div>

      <AccessModal />
    </div>
  );
};
